import React from 'react';
import { RiAlertFill } from 'react-icons/ri';
import AuthButton from '../AuthButton/AuthButton';
import { useSelector } from 'react-redux';
import { POPUP } from '../../Actions/actions';
import { useDispatch } from 'react-redux';

const SessionExpiredModal = () => {
    const { popup } = useSelector(state => state.userReducer);
    const dispatch =useDispatch()
    if (!popup) return null;

    return (
        <div className="fixed inset-0 z-[9999]">
            {/* Backdrop that covers entire screen */}
            <div className="fixed inset-0 bg-black opacity-50 z-[9998]" />

            {/* Modal */}
            <div className="fixed inset-0 flex items-center justify-center z-[9999]">
                <div className="bg-white rounded-lg px-3 pt-3 max-w-lg w-full shadow-lg sm:mx-5 md:mx-0 text-center">
                    <div className="mb-4">
                        <span className="inline-flex items-center justify-center p-3 bg-red-100 rounded-full">
                            <RiAlertFill className="w-10 h-10 text-red-600" />
                        </span>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Session Expired</h2>
                    <p className="text-gray-500 mb-6 w-[70%] mx-auto">
                        Your session has expired due to inactivity or token expiration. Please refresh your session.
                    </p>

                    <div className="flex justify-center pb-3">
                        <AuthButton
                            onClick={() => {
                                dispatch({ type: POPUP, payload: false });
                                window.location.reload();
                            }}
                            width={'50%'}
                            title={'Refresh Session'}
                            className="bg-primary text-white px-4 rounded-md"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SessionExpiredModal;
